import $ from 'jquery';
import EventEmitter from '../event-emitter';
import inherit from '../inherit';
import * as events from './events';

function YoutubePlayer(containerId, configs) {
  EventEmitter.call(this);
  this.containerId = containerId;
  this.configs = configs;
  this.isInitialLoad = true;
  this.player = null;
}

inherit(YoutubePlayer, EventEmitter, {
  eventCallbacks() {
    return {
      events: {
        onReady: (e) => this.emit(events.READY, e),
        onStateChange: (e) => this.emit(events.STATE_CHANGE, e),
        onError: (e) => this.emit(events.ERROR, e)
      }
    };
  },
  load(videoId) {
    if (this.isInitialLoad) {
      SF.loadModule('youtube', (status) => {
        if (status === 'success') {
          this.emit(events.LOAD, videoId);
          this.isInitialLoad = false;
        } else {
          this.emit(events.ERROR, new Error('Failed to load Youtube Iframe API script'));
        }
      });
    } else {
      // YT.Player.destroy가 내부적으로 setTimeout을 쓰는 듯 보인다.
      // 바로 load이벤트를 실행할 경우 완전히 destroy 사이클이 끝나기 전에 다시 플레이어를 실행시켜 에러가 생긴다.
      setTimeout(() => {
        this.emit(events.LOAD, videoId);
      }, 0);
    }
  },
  play(videoId) {
    const options = $.extend({}, this.configs, this.eventCallbacks(), { videoId });
    if (this.isInitialLoad) {
      window.onYouTubeIframeAPIReady = () => this.player = new window.YT.Player(this.containerId, options);
    } else {
      this.player = new window.YT.Player(this.containerId, options);
    }
  },
  destroy() {
    if (this.player) {
      this.player.destroy();
      this.player = null;
      this.emit(events.DESTROY);
    }
  }
});
export default YoutubePlayer;


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/youtube-player/youtube.js
 **/